/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */


(() => {
  const targetHandles = new Set([
    'jig-of-the-month-club-3-months-prepaid',
    'jig-of-the-month-club-12-months-prepaid'
  ]);

  const productMatch = window.location.pathname.match(/\/products\/([^/?#]+)/);
  const handle = productMatch ? productMatch[1] : '';

  if (!targetHandles.has(handle)) return;

  function formatVariantPrice(variant) {
    const currency = window.Shopify?.currency?.active || 'USD';
    const locale = document.documentElement.lang || 'en-US';

    const formatted = new Intl.NumberFormat(locale, {
      style: 'currency',
      currency
    }).format(variant.price / 100);

    return window.theme?.currencyCodeEnabled
      ? `${formatted} ${currency}`
      : formatted;
  }

  function updateMainPrice(variant) {
    if (!variant) return;

    const priceElement = document.querySelector(
      '.product-form__info-list .price-list > .price:not(.price--compare)'
    );

    if (!priceElement) return;

    const accessibleLabel = priceElement
      .querySelector('.visually-hidden')
      ?.cloneNode(true);

    priceElement.replaceChildren();

    if (accessibleLabel) {
      priceElement.appendChild(accessibleLabel);
    }

    priceElement.appendChild(
      document.createTextNode(formatVariantPrice(variant))
    );
  }

  document.addEventListener('variant:changed', (event) => {
    const variant = event.detail?.variant;

    if (!variant) return;

    updateMainPrice(variant);

    window.setTimeout(() => updateMainPrice(variant), 50);
    window.setTimeout(() => updateMainPrice(variant), 250);
  });
})();